<template>
    <v-container class="secondary-font py-0 my-0" style="font-size: 1rem; height: 200px;">
        <template v-if="!isLoaded">
            <v-skeleton-loader type="card" height="100px" class="mb-2" />
            <v-skeleton-loader type="card" height="100px" />
        </template>
        <template v-else>
            <v-card color="#140542" class="justify-center align-center py-6 justify-center align-center rounded-0 elevation-0" style="display: flex;" width="250px">
                <!-- {{ getMatchTitle() }} -->
                <img :src="require('@/assets/FIMBA.png')" height="42" width="auto" contain/>
            </v-card>
            <div class="live-score-wrapper">
                <div class="live-score-logo px-2 py-0 my-0">
                    <img height="auto" width="150px" :src="require('@/assets/main_logo.png')">
                </div>
                <div class="live-score-rows">
                    <v-row style="height: 98.5px; background-color: #140542; color: white;" class="px-0 py-0 my-0 xl" align="center" justify="center">
                        <v-col cols="4" align="start" class="px-0 pl-5">
                            <div style="display: inline-block; font-size: 1.3rem;">
                                <div> {{ getMatchCategory() }} </div>
                            </div>
                        </v-col>
                        <v-col cols="4" align="center" class="px-0">
                            <div class="font-weight-bold team-name" style="font-size: 1.3rem;">
                                <!-- {{ matchDetails.team1.nickName ? matchDetails.team1.nickName : matchDetails.team1.name }} -->
                                {{ getTeamName(matchDetails.team1.name) }}
                            </div>
                            <div>
                                <span v-for="n in team1Fouls >= 5 ? 5 : team1Fouls" :key="`n-${n}`">
                                    <v-icon large :color="team1Fouls >= 5 ? 'red' : '#e3f905'">mdi-minus-thick</v-icon>
                                </span>
                                <span v-for="w in ((5 - team1Fouls) <= 0 ? 0 : (5 - team1Fouls))" :key="`w-${w}`">
                                    <v-icon large color="white" class="icon-outline">mdi-minus-thick</v-icon>
                                </span>
                            </div>
                        </v-col>
                        <v-col cols="2" align="end" class="px-0 py-0 my-0">
                            <v-avatar style="border-radius: 10px;" size="80px" color="white" class="mr-3">
                                <img :src="getCountryFlagUrl(matchDetails.team1.name)" height="80px" width="auto">
                            </v-avatar>
                        </v-col>
                        <v-col cols="2" align="center" style="font-size: 2.5rem;" class="px-0" :style="`border-left: 8px solid ${matchDetails.team1.color};`">
                            <span>{{ team1Score }}</span>
                        </v-col>
                    </v-row>
                    <v-row class="py-0 my-0" justify="center" align="center">
                        <v-col cols="12" class="py-0 my-0 custom-teal" style="height: 3px;" />
                    </v-row>
                    <v-row style="height: 98.5px; background-color: #140542; color: white;" class="px-0 my-0 py-0 xl" align="center" justify="center">
                        <v-col cols="1" style="font-size: 1.7rem;" align="start" class="py-0 my-0">
                            {{ periodNames[quarter] }}
                        </v-col>
                        <v-col cols="3" style="font-size: 2rem;" align="center" class="py-0 my-0">
                            {{ `${minutes}:${seconds}` }}
                        </v-col>
                        <!-- <v-col cols="1" style="color: white; background-color: #b03e00; font-size: 1rem;" class="px-0">
                            24
                        </v-col> -->
                        <v-col cols="4" align="center" class="px-0">
                            <div class="font-weight-bold team-name" style="font-size: 1.3rem;">
                                <!-- {{ matchDetails.team2.nickName ? matchDetails.team2.nickName : matchDetails.team2.name }} -->
                                {{ getTeamName(matchDetails.team2.name) }}
                            </div>
                            <div>
                                <span v-for="i in team2Fouls >= 5 ? 5 : team2Fouls" :key="`i-${i}`">
                                    <v-icon large :color="team2Fouls >= 5 ? 'red' : '#e3f905'">mdi-minus-thick</v-icon>
                                </span>
                                <span v-for="j in ((5 - team2Fouls) <= 0 ? 0 : (5 - team2Fouls))" :key="`j-${j}`">
                                    <v-icon large color="white" class="icon-outline">mdi-minus-thick</v-icon>
                                </span>
                            </div>
                        </v-col>
                        <v-col cols="2" align="end" class="px-0 py-0 my-0">
                            <v-avatar style="border-radius: 10px;" size="80px" color="white" class="mr-3">
                                <img :src="getCountryFlagUrl(matchDetails.team2.name)" height="80px" width="auto">
                            </v-avatar>
                        </v-col>
                        <v-col cols="2" align="center" style="font-size: 2.5rem;" class="px-0" :style="`border-left: 8px solid ${matchDetails.team2.color};`">
                            <span>{{ team2Score }}</span>
                        </v-col>
                    </v-row>
                </div>
            </div>
        </template>
    </v-container>
</template>

<script>
    import matchService from '@/services/match'
    export default {
        props: {
            id: {
                type: String,
                required: true
            }
        },
        data() {
            return {
                assetsUrl: 'https://storage.googleapis.com',
                periodNames: {
                    0: '1st',
                    1: '1st',
                    2: '2nd',
                    3: '3rd',
                    4: '4th',
                    5: 'OT',
                    6: '2nd OT',
                    7: '3rd OT',
                    8: '4th OT',
                    9: '5th OT',
                    10: '6th OT'
                },
                events: [],
                timerEvent: null,
                timer: null,
                paused: true,
                quarter: 1,
                timerInterval: null,
                matchDetails: {
                    team1: { name: '', points: 0, personalFouls: 0, technicalFouls: 0, logo: '', color: '' },
                    team2: { name: '', points: 0, personalFouls: 0, technicalFouls: 0, logo: '', color: '' },
                    leagueTitle: '',
                    round: '',
                    cup: false,
                    phase: ''
                }
            }
        },
        computed: {
            team1Score() {
                return this.matchDetails.team1Score ? this.matchDetails.team1Score : this.matchDetails.team1.points
            },
            team2Score() {
                return this.matchDetails.team2Score ? this.matchDetails.team2Score : this.matchDetails.team2.points
            },
            team1Fouls() {
                return this.matchDetails.team1.personalFouls + this.matchDetails.team1.technicalFouls + this.matchDetails.team1.unsportsmanlikeFouls
            },
            team2Fouls() {
                return this.matchDetails.team2.personalFouls + this.matchDetails.team2.technicalFouls + this.matchDetails.team2.unsportsmanlikeFouls
            },
            minutes() {
                const t = Math.max(0, Number(this.timer) || 0)
                const temp = Math.floor(t / 60000)
                return (temp < 10 ? '0' : '') + temp
            },
            seconds() {
                const t = Math.max(0, Number(this.timer) || 0)
                const temp = Math.floor((t % 60000) / 1000)
                return (temp < 10 ? '0' : '') + temp
            },
            isLoaded() {
                // Adjust this logic as needed for your data
                return !!this.matchDetails.team1.name && !!this.matchDetails.team2.name
            }
        },
        beforeDestroy() {
            if (this.scoreEventSource) this.scoreEventSource.close()
            if (this.timerEventSource) this.timerEventSource.close()
            if (this.timerInterval) {
                clearInterval(this.timerInterval)
                this.timerInterval = null
            }
        },
        mounted() {
            this.initScoreEventSource()
            this.initTimerEventSource()
        },
        created() {
            this.timer = 600000
            if (screen === 'live-score') {
                this.$emit('setShowScreen', screen)
            } else if (this.quarter === 1 && this.paused) {
                return this.$emit('setShowScreen', 'pregame')
            }
            // this.hasActivePlayers().then(screen => {
            //     if (screen === 'live-score') {
            //         this.$emit('setShowScreen', screen)
            //     } else if (this.quarter === 1 && this.paused) {
            //         return this.$emit('setShowScreen', 'pregame')
            //     }
            // })
        },
        methods: {
            getCountryFlagUrl(teamName) {
                const country = teamName.split('-')[0].trim()
                console.log('Country:', country)
                const countryCode = this.$countries.getAlpha2Code(country, 'en')
                console.log('Country code:', countryCode)
                if (country === 'MOLDOVA') {
                    return 'https://flagcdn.com/w320/md.png'
                }
                if (!countryCode) {
                    return `https://flagcdn.com/w320/${country.toLowerCase()}.png`
                }
                return `https://flagcdn.com/w320/${countryCode.toLowerCase()}.png`
            },
            getTeamName(name) {
                const parts = name.split('-')
                if (parts.length >= 3) {
                    return parts[parts.length - 3].trim()
                }
                return name
            },
            getMatchCategory() {
                const temp = this.matchDetails.team1.name.split('-')
                return temp[temp.length - 1].trim() + ' | ' + temp[temp.length - 2].trim()
            },
            hasActivePlayers() {
                return matchService.getActivePlayers(this.$route.params.id).then(resp => {
                    if (resp.data.team1Players.length > 0 || resp.data.team2Players.length > 0) {
                        return 'live-score'
                    }
                }).catch(e => {
                    console.error('Failed to load active players', e)
                })
            },
            getMatchTitle() {
                if (this.matchDetails.customRoundText) {
                    return this.matchDetails.customRoundText
                } else if (this.matchDetails.cupLeague) {
                    return this.matchDetails.cupLeague.title
                } else if (this.matchDetails.leagueTitle) {
                    return this.matchDetails.leagueTitle
                } else {
                    return 'Τελικός'
                }
            },
            initScoreEventSource() {
                const url = `${process.env.VUE_APP_API_HOST_DOMAIN}/events/${this.id}/score-subscribe`
                this.scoreEventSource = new EventSource(url)

                this.scoreEventSource.addEventListener('score', (event) => {
                    this.matchDetails = JSON.parse(event.data)
                })

                this.scoreEventSource.onerror = (error) => {
                    console.error('SSE error:', error)
                    this.scoreEventSource.close()
                    setTimeout(() => this.initScoreEventSource(), 1000)// Retry after 1 second
                }
            },
            initTimerEventSource() {
                const url = `${process.env.VUE_APP_API_HOST_DOMAIN}/events/${this.id}/timer-subscribe`
                this.timerEventSource = new EventSource(url)

                this.timerEventSource.addEventListener('timer', (event) => {
                    this.timerEvent = JSON.parse(event.data)
                    this.timer = this.timerEvent.timer
                    this.quarter = this.timerEvent.period
                    if (this.timerEvent.timerEventStatus === 'stop') {
                        this.paused = true
                        clearInterval(this.timerInterval)
                        if (this.quarter === 3 && this.paused && Number(this.timer) === 600000) {
                            this.$emit('setShowScreen', 'half-time')
                        } else if (this.quarter === 2 && this.paused && Number(this.timer) === 600000) {
                            return this.$emit('setShowScreen', 'timeout')
                        } else if (this.quarter > 4 && this.paused && Number(this.timer) === 300000) {
                            this.$emit('setShowScreen', 'full-time')
                        } else if (this.paused && this.timerEvent.timerEventStatus === 'timeout') {
                            return this.$emit('setShowScreen', 'timeout')
                        }
                    } else if (this.timerEvent.timerEventStatus === 'timeout') {
                        this.paused = true
                        clearInterval(this.timerInterval)
                        this.$emit('setShowScreen', 'timeout')
                    } else if (this.timer > 0 && this.timerEvent.timerEventStatus === 'start') {
                        if (Number(this.timer) === 600000) {
                            this.$emit('setShowScreen', 'starters')
                        } else {
                            this.$emit('setShowScreen', 'live-score')
                        }
                        this.paused = false
                        // ensure we don't create multiple intervals
                        if (this.timerInterval) clearInterval(this.timerInterval)
                        this.timerInterval = setInterval(() => {
                            this.timer = Math.max(0, Number(this.timer) - 1000)
                            if (this.timer === 0) {
                                clearInterval(this.timerInterval)
                                this.timerInterval = null
                                this.paused = true
                            }
                        }, 1000)
                    } else if (this.timerEvent.timerEventStatus === 'end_match') {
                        this.paused = true
                        clearInterval(this.timerInterval)
                        this.$emit('setShowScreen', 'full-time')
                    }
                })

                this.timerEventSource.onerror = (error) => {
                    console.error('SSE error:', error)
                    this.timerEventSource.close()
                    setTimeout(() => this.initTimerEventSource(), 1000) // Retry after 1 second
                }
            }
        }
    }
</script>

<style lang="css" scoped>
    .live-score-wrapper {
        display: flex;
        background-color: #140542;
    }

    .live-score-logo {
        height: 200px;
        display: flex;
        align-items: center;
        flex: 0 0 auto;
    }

    .live-score-rows {
        flex: 1;
        min-width: 600px;
    }

    .team-name {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        text-align: center;
        max-width: 100%; /* or set a specific width if needed */
    }

    .icon-outline {
        text-shadow:
            -1px -1px 0 #000,
            1px -1px 0 #000,
            -1px  1px 0 #000,
            1px  1px 0 #000;
    }
</style>
